// Module
var code = "<record-form-view fields=\"machinesMoveComponentController.formFields\" model=\"machinesMoveComponentController.model\" title=\"Move Machines\" on-submit=\"machinesMoveComponentController.submit(formViewController)\" on-cancel=\"machinesMoveComponentController.cancel(formViewController)\"></record-form-view> ";
// Exports
export default code;